<div class="sticky-lg-top" id="sidebar">
  <div style="padding-top: 48px;">
  <div class="d-flex flex-column flex-shrink-0 p-3 bg-light" style="width: 200px;">

    <ul class="nav nav-pills flex-column mb-auto">
      <li class="nav-item pb-1">
        <div type="button" class="btn btn-link btn-sm btn-light no-underline  text-dark  w-md-auto d-flex" routerLink="/">
          <span class=" me-2" style="width: 1.5em;">📝</span>
          <span>Summarizer</span></div>
      </li>
      <li class="nav-item">
        <div type="button" class="btn btn-link btn-sm btn-light no-underline  text-dark  w-md-auto d-flex" routerLink="/solver">
          <span class=" me-2" style="width: 1.5em;">💡</span>
          <span>Solver</span></div>
      </li>

    </ul>
    <hr>
    <ul class="nav nav-pills flex-column mb-auto">
      <li class="nav-item pb-1">
        <div type="button" class="btn btn-sm btn-link no-underline btn-light text-primary fw-bold w-md-auto d-flex" routerLink="/plans">
          <span class=" me-2" style="width: 1.5em;">👑</span>
          <span>{{ "PLANS_AND_PRICING" | translate }}</span></div>
      </li>


    </ul>
    <hr>
<!--    <div class="dropdown">-->
<!--      <a href="#" class="d-flex align-items-center link-dark text-decoration-none dropdown-toggle" id="dropdownUser2" data-bs-toggle="dropdown" aria-expanded="false">-->
<!--        <img src="Sidebars%20%C2%B7%20Bootstrap%20v5.0_files/98681.jpg" alt="" width="32" height="32" class="rounded-circle me-2">-->
<!--        <strong>mdo</strong>-->
<!--      </a>-->

<!--      <ul class="dropdown-menu text-small shadow" aria-labelledby="dropdownUser2">-->
<!--        <li><a class="dropdown-item" href="#">New project...</a></li>-->
<!--        <li><a class="dropdown-item" href="#">Settings</a></li>-->
<!--        <li><a class="dropdown-item" href="#">Profile</a></li>-->
<!--        <li><hr class="dropdown-divider"></li>-->

<!--        <li><a class="dropdown-item" href="#">Sign out</a></li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
</div>
